'use client';
import React from 'react';

const BASE = '/customer-service/shipping-and-payment-terms';

const paymentMethods = [
  {
    id: 'bank_transfer',
    href: `${BASE}#bank_transfer`,
    title: 'Vorkasse – Details anzeigen',
    ariaLabel: 'Vorkasse Zahlungsdetails',
    src: '/static/img/payment-method/vorkasse.webp',
    alt: 'Vorkasse (Banküberweisung)',
  },
  {
    id: 'card',
    href: `${BASE}#card`,
    title: 'Kreditkarte – Details anzeigen',
    ariaLabel: 'Kreditkarte Zahlungsdetails',
    src: '/static/img/payment-method/kreditkarte.webp',
    alt: 'Kreditkarte (Stripe)',
  },
  {
    id: 'klarna',
    href: `${BASE}#klarna`,
    title: 'Klarna – Details anzeigen',
    ariaLabel: 'Klarna Zahlungsdetails',
    src: '/static/img/payment-method/klarna.webp',
    alt: 'Klarna',
  },
  {
    id: 'paypal',
    href: `${BASE}#paypal`,
    title: 'PayPal – Details anzeigen',
    ariaLabel: 'PayPal Zahlungsdetails',
    src: '/static/img/payment-method/paypal.webp',
    alt: 'PayPal',
  },
  {
    id: 'google_pay',
    href: `${BASE}#google_pay`,
    title: 'Google Pay – Details anzeigen',
    ariaLabel: 'Google Pay Zahlungsdetails',
    src: '/static/img/payment-method/googlepay.webp',
    alt: 'Google Pay',
  },
  {
    id: 'apple_pay',
    href: `${BASE}#apple_pay`,
    title: 'Apple Pay – Details anzeigen',
    ariaLabel: 'Apple Pay Zahlungsdetails',
    src: '/static/img/payment-method/applepay.webp',
    alt: 'Apple Pay',
  },
  {
    id: 'sepa_debit',
    href: `${BASE}#sepa_debit`,
    title: 'Lastschrift – Details anzeigen',
    ariaLabel: 'Lastschrift Zahlungsdetails',
    src: '/static/img/payment-method/lastschrift.webp',
    alt: 'Lastschrift (SEPA)',
  },
  {
    id: 'invoice',
    href: `${BASE}#invoice`,
    title: 'Rechnung – Details anzeigen',
    ariaLabel: 'Rechnung Zahlungsdetails',
    src: '/static/img/payment-method/rechnung.webp',
    alt: 'Rechnung',
  },
];

const LockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="14"
    height="14"
    fill="none"
    style={{
      display: 'inline-block',
      marginRight: '4px',
      flexShrink: 0,
      verticalAlign: 'middle',
      position: 'relative',
      top: '-1px',
      color: '#5fa30f',
    }}
  >
    <rect
      x="5"
      y="10.5"
      width="14"
      height="9.5"
      rx="1.6"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path
      d="M8 10.5V7.8a4 4 0 0 1 8 0v2.7"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="14.8" r="1.15" fill="currentColor" />
    <path
      d="M12 15.9v1.6"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

const FooterCopyright = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="ps-footer__copyright text-center p-4 bg-gray-100 text-gray-700">
      <p className="text-sm mt-2 flex items-center justify-center gap-1.5">
        <LockIcon />
        Sichere SSL-verschlüsselte Zahlungen
      </p>

      <div className="payment-grid">
        {paymentMethods.map((method) => (
          <a
            key={method.id}
            href={method.href}
            className="payment-link"
            title={method.title}
            aria-label={method.ariaLabel}
          >
            <img
              src={method.src}
              alt={method.alt}
              width="75"
              height="38"
              className="payment-img"
              suppressHydrationWarning
            />
          </a>
        ))}
      </div>

      <style jsx>{`
        .payment-grid {
          margin-top: 8px;
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          justify-items: center;
          align-items: center;
          max-width: 340px;
          margin-left: auto;
          margin-right: auto;
        }
        .payment-link {
          display: block;
          width: 100%;
          margin-right: 10px;
          margin-bottom: 10px;
          transition: opacity 0.2s ease;
        }
        .payment-link:hover {
          opacity: 0.8;
        }
        .payment-img {
          display: block;
          width: 100%;
          height: auto;
          max-width: 75px;
          margin: 0 auto;
        }
        .ps-footer__copyright {
          padding-bottom: 45px !important;
        }
        @media (min-width: 768px) {
          .payment-grid {
            display: flex;
            flex-wrap: nowrap;
            justify-content: center;
            max-width: none;
            padding-bottom: 0;
          }
          .payment-link {
            width: 75px;
            flex-shrink: 0;
            margin-bottom: 0;
          }
          .payment-link:last-child {
            margin-right: 0;
          }
          .ps-footer__copyright {
            padding-bottom: 1rem !important;
          }
        }
      `}</style>

      <p className="text-sm">&copy; {currentYear} Rawento. All Rights Reserved</p>
    </div>
  );
};

export default FooterCopyright;